import { LoadingTag } from '@zg-rentals/loading-components';

import { useRentalManagerMaintenanceConfigWebApiHandler_config } from '@zg-rentals/rental-manager-env';

import type { TagPropsInterface } from '@zillow/constellation-10';
import type { MaintenanceTaskStatusDto } from '@zg-rentals/rental-manager-env';

type Props = {
  status: MaintenanceTaskStatusDto;
  size?: 'sm' | 'md';
  isLoading?: boolean;
};

export const StatusTag = ({ status, size = 'sm', isLoading = false }: Props) => {
  const { data: config } = useRentalManagerMaintenanceConfigWebApiHandler_config({ staleTime: Infinity });

  const statusDetails = config && config.statuses.find((option) => option.persistentString === status.persistentString);

  if (statusDetails || isLoading) {
    return (
      <LoadingTag
        tone={statusDetails?.tag?.appearance as TagPropsInterface['tone']}
        size={size}
        isLoading={isLoading}
        loadingWidth="100px"
      >
        {status?.tag?.text}
      </LoadingTag>
    );
  }
  return null;
};
